import baseapi from "../baseAPI";

export const NotificationListAPI = async (setNotifications, setLoading, currentPage, perpagedata, setPageCount) =>
{
    setLoading(true);

    try
    {
        const response = await baseapi.get("/api/admin/notifications?page=" + currentPage + "&per_page=" + perpagedata);

        //console.log("Data got successfully", response.data.data.data);
        //let userdata = ['ram', 'shyam', 'rohit'];
        setNotifications(response.data.data.data);
        setLoading(false);

        if(response.data.data.data.length > 0)
        {
            //console.log('Total count====='+response.data.data.total);
            let pagecount = Math.ceil(response.data.data.total / perpagedata);

            //console.log('page count====' + pagecount);

            setPageCount(pagecount);
        }
    }
    catch(error)
    {
        console.error("Error in user list:", error);
        setLoading(false);
    }
}


